/**
 * 存储适配器实现
 * 提供 LocalStorage 和 SessionStorage 的统一适配器
 */

import type { IStorage } from '../types/storage'

/**
 * LocalStorage 适配器
 * 容错处理：存储不可用时静默降级
 */
export class LocalStorageAdapter implements IStorage {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  }

  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value)
    } catch {
      // localStorage 不可用时静默忽略
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch {
      // localStorage 不可用时静默忽略
    }
  }
}

/**
 * SessionStorage 适配器
 * 容错处理：存储不可用时静默降级
 */
export class SessionStorageAdapter implements IStorage {
  getItem(key: string): string | null {
    try {
      return sessionStorage.getItem(key)
    } catch {
      return null
    }
  }

  setItem(key: string, value: string): void {
    try {
      sessionStorage.setItem(key, value)
    } catch {
      // sessionStorage 不可用时静默忽略
    }
  }

  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key)
    } catch {
      // sessionStorage 不可用时静默忽略
    }
  }
}

/** LocalStorage 适配器单例 */
export const localStorageAdapter: IStorage = new LocalStorageAdapter()

/** SessionStorage 适配器单例 */
export const sessionStorageAdapter: IStorage = new SessionStorageAdapter()
